module.exports = __webpack_public_path__ + "img/test-5-8-2-glitch.773eba31.png";